import { BatteryFullIcon, SignalIcon, WifiIcon } from "lucide-react";
import { PropsWithChildren, ReactNode } from "react";
import { cn } from "web-design-system";

export const PHONE_WIDTH = 320;
export const PHONE_HEIGHT = 680;

type PhoneFrameProps = PropsWithChildren<{
  footer?: ReactNode;
  className?: string;
}>;

/**
 * A phone shell for previewing the investor mobile app. The preview mirrors the
 * app's own light theme, so it uses the app palette instead of the portal tokens.
 */
export function PhoneFrame({ footer, className, children }: PhoneFrameProps) {
  return (
    <div
      style={{ width: PHONE_WIDTH, height: PHONE_HEIGHT }}
      className={cn(
        "flex flex-col overflow-hidden rounded-[28px] border border-stone-200 bg-white text-stone-900 shadow-xl",
        className
      )}
    >
      <div className="flex items-center justify-between px-5 pt-4 pb-2 text-xs font-medium">
        <span>9:30</span>
        <div className="flex items-center gap-1 [&_svg]:size-3.5">
          <WifiIcon />
          <SignalIcon />
          <BatteryFullIcon />
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
      {footer}
    </div>
  );
}
